import cn from 'classnames';
import { FC } from 'react';

import { Icon, Tooltip } from '@/shared/ui';

import styles from './TemplateFieldView.module.scss';

type Props = {
  confirmLabel: string;
  rejectLabel: string;
  onConfirm: () => void;
  onReject: () => void;
};

// What waits for the clinician, a value or a part of one (a tooth's mark, a
// table's cell) AI assumed or suggested: confirm over reject, one compact
// control beside it.
export const AssumptionActions: FC<Props> = ({
  confirmLabel,
  rejectLabel,
  onConfirm,
  onReject,
}) => (
  <span
    className={styles.assumptionActions}
    data-component="workspace-note-assumption-actions"
  >
    <Tooltip.Primary content={confirmLabel}>
      <button
        type="button"
        className={cn(styles.assumptionAction, styles.confirmAssumption)}
        aria-label={confirmLabel}
        data-component="workspace-note-confirm-assumption"
        onClick={onConfirm}
      >
        <Icon name="check" size={12} />
      </button>
    </Tooltip.Primary>
    <Tooltip.Primary content={rejectLabel} side="bottom">
      <button
        type="button"
        className={cn(styles.assumptionAction, styles.rejectAssumption)}
        aria-label={rejectLabel}
        data-component="workspace-note-reject-assumption"
        onClick={onReject}
      >
        <Icon name="close" size={12} />
      </button>
    </Tooltip.Primary>
  </span>
);
